<div class="mood-checkin-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <div class="header-content">
      <h2 class="dialog-title">{{ data.dayName }}, {{ data.date }}</h2>
    </div>
    <button mat-icon-button class="close-button" (click)="closeDialog()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="dialog-content">
    <!-- Mood Checkins Section -->
    <div class="section" *ngIf="data.moodCheckins && data.moodCheckins.length > 0">
      <h3 class="section-title">Mood Checkins</h3>
      <div class="cards-container">
        <div class="mood-card" *ngFor="let checkin of data.moodCheckins">
          <!-- First Row: Emoji, Feeling, Time -->
          <div class="card-row first-row">
            <img 
              [src]="getFeelingEmoji(checkin.feeling)" 
              [alt]="checkin.feeling" 
              class="feeling-emoji"
              *ngIf="getFeelingEmoji(checkin.feeling)"
            />
            <div class="feeling-info">
              <span class="feeling-text">{{ checkin.feeling }}</span>
              <span class="feeling-time">{{ formatTime(checkin.modifiedDateTime) }}</span>
            </div>
          </div>

          <!-- Second Row: Notes -->
          <div class="card-row" *ngIf="checkin.notes">
            <p class="notes-text"><strong>Notes:-</strong> {{ checkin.notes }}</p>
          </div>

          <!-- Third Row: Heald Toolkit (only when present) -->
          <div class="card-row" *ngIf="checkin.healdToolKit">
            <p class="notes-text">
              <strong>Try Heald Toolkit :</strong> {{ checkin.healdToolKit.text }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Energy Levels Section -->
    <div class="section" *ngIf="data.energyLevels && data.energyLevels.length > 0">
      <h3 class="section-title">Energy Levels</h3>
      <div class="cards-container">
        <div class="energy-card" *ngFor="let energy of data.energyLevels">
          <div class="energy-content">
            <img 
              [src]="getEnergyLevelIcon(energy.level)" 
              alt="Energy Level" 
              class="energy-image"
            />
            <div class="energy-info">
              <div class="energy-level-text" *ngIf="energyLevelMap[energy.level]">
                <div class="energy-title">{{ energyLevelMap[energy.level].title }}</div>
                <div class="energy-subtitle">{{ energyLevelMap[energy.level].subtitle }}</div>
              </div>
              <div class="logged-at">
                Logged at {{ formatTime(energy.createdDateTime) }}
              </div>
            </div>
          </div>
          <div class="energy-details energy-details-full" *ngIf="energy.symptom || energy.reflectOnIt || energy.reset">
            <div class="energy-detail" *ngIf="energy.symptom">
              <strong>Symptom :</strong> {{ energy.symptom }}
            </div>
            <div class="energy-detail" *ngIf="energy.reflectOnIt">
              <strong>Reflect :</strong> {{ energy.reflectOnIt }}
            </div>
            <div class="energy-detail" *ngIf="energy.reset">
              <strong>Reset :</strong> {{ energy.reset }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- No Data Message -->
    <div class="no-data" *ngIf="(!data.moodCheckins || data.moodCheckins.length === 0) && (!data.energyLevels || data.energyLevels.length === 0)">
      <p>No entries found for this date.</p>
    </div>
  </div>
</div>

<!-- Image Lightbox -->
<div class="lightbox-overlay" *ngIf="selectedImage" (click)="closeImageLightbox()">
  <div class="lightbox-content" (click)="$event.stopPropagation()">
    <button mat-icon-button class="lightbox-close" (click)="closeImageLightbox()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
    <img [src]="selectedImage" alt="Full size image" class="lightbox-image" />
  </div>
</div>

